module.exports = __webpack_public_path__ + "static/product_track-353e173c904f38fb1fa4d7bb3b95eb64.png";